module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title-no",
    attrs: {
      "id": "C1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("CHAPTER ONE")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "title-head"
  }, [_vm._v("Superstars of"), _c('br'), _vm._v("Early Denton")]), _vm._v(" "), _c('p', {
    staticClass: "paraG"
  }, [_c('i', [_vm._v("Pioneers lay the roads for those who follow to walk on")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Unknown")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The threads that bind the individuals selected for this chapter weave the fabric of the rest of the book. Courageous, hearty souls, these men and women were merchants, lawyers, judges, farmers, ranchers, bankers, sheriffs, soldiers, and even outlaws who laid the groundwork for the dynamic Denton of today. Mothers, daughters, and wives fashioned the city’s diverse cultural and domestic tapestry.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The four streets that rim the immediate Downtown Square are named for indigenous trees: Oak, Elm, Locust, and Hickory. Encircling those main arteries are Pecan, Walnut, Ash (now Austin), and Cedar Streets. Chestnut, Mulberry, and Sycamore are feeder streets into and out of the residential areas to downtown. Oak Street is also known as “Silk Stocking Row” for the large homes of prominent families. The Oak/Hickory Historic District encompasses the last remaining older stately homes in the city.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Small towns often named their streets after early settlers or national heroes. In Denton, this occurs in the offshoot residential streets. This chapter highlights the history and stories of these pioneers and the streets named in their honor.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ENTON")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUNTY")]), _c('br'), _vm._v("by Otis Grenwood Welch")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("There’s no country on earth"), _c('br'), _vm._v("Can equal our state"), _c('br'), _vm._v("If people will work"), _c('br'), _vm._v("And patiently wait,")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Till the iron horse comes"), _c('br'), _vm._v("With his immigrant train,"), _c('br'), _vm._v("To bear back our cotton,"), _c('br'), _vm._v("Our wool and our grain.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("The climate and water,"), _c('br'), _vm._v("The timber and land,"), _c('br'), _vm._v("Need only the touch"), _c('br'), _vm._v("Of the laborer’s hand")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("To make Denton County"), _c('br'), _vm._v("In all that is great"), _c('br'), _vm._v("The garden of Texas"), _c('br'), _vm._v("The great Empire state.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("And Denton a city"), _c('br'), _vm._v("Of worldwide renown"), _c('br'), _vm._v("Lewisville, Pilot Point"), _c('br'), _vm._v("And Elizabethtown.")])]), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F1.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Ladies of the Club")])]), _c('br'), _vm._v("The Ariel Club, established in 1891, is Denton’s oldest club for women. It focuses on charity, education, and literary pursuits. These 1904 Ariel Club members, dressed in flowing dresses and fancy hats, are seated on the lawn of the home of Mrs. John C. Coit. Their surnames are found throughout Denton’s history. Many of their families have streets named for them, including the following: Williams, Mounts, Wright, Hann, Brooks, Allen, Smith, Long, Coit, Carroll, and Edwards. Married to legendary men, these women were legends themselves through their volunteer activities and community advocacy. (Courtesy of DRC.)")])])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('img', {
    staticClass: "img-50",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F2.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Father of Denton")])]), _c('br'), _vm._v("After opening his law office in 1852 in Denton County, Otis Greenwood Welch (1822–1880) served as legal advisor in the formation of the city of Denton. Welch was captain of Company I First Choctaw and Chickasaw Mounted Rifles in 1861 and later transferred to the 29th Texas Cavalry. After the war, Colonel Welch resumed practicing law on the Denton Square. (Courtesy of IOOF.)")])])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img-40",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Carroll Boulevard’s Namesake")])]), _c('br'), _vm._v("Joseph Alexander Carroll (1832–1891) came to Denton in 1854; three years later, he drew the map for the town lots. He became a lawyer, served in the Civil War in the 29th Texas Cavalry, and returned home to resume his law practice. In 1876, he was elected 10th District court judge (currently the 16th District). Carroll served as mayor of Denton and charter regent of Texas Normal College. He was president of Exchange National Bank until his death. (Courtesy of IOOF.)")])])]), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img-40",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F4.jpg"
    }
  })])]), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Sheriff and Merchant")])]), _c('br'), _vm._v("As Denton County sheriff, Charles Alexander Williams (1832–1922) auctioned off Denton town lots in 1857. He was one of the first men to enlist in the Confederate army, serving as a private with the 18th Texas Cavalry. After the war, he was elected to a second term as sheriff (1866–1867). Williams and his wife, Virginia (d. 1926), are shown here on the occasion of their 50th wedding anniversary with their son, Will, standing behind them. Williams operated the Williams Dry Goods Store for 45 years, walking to work every day until his death at age 90. (Courtesy of DPL.)")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Prominent Families")])]), _c('br'), _vm._v("Many prominent Denton families attended the Williams family picnic in Decatur, including the people posing for this photograph. They are, from left to right, as follows: (first row) John Douglas, J.P. “Pink” Magee, Bertha Saufley, and Effie Collins (Mrs. Ted) Ponder; (second row) Lee Williams and Effie Wright; (third row) Dr. Priestly Lipscomb, Joe A. Long, Lula Blewett, Will Williams, and Lenora Hann. (Courtesy of DPL.)")])])]), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F6.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Molded from Pioneer Clay")])]), _c('br'), _vm._v("The influential pioneer family of James Madison Daugherty was instrumental in the settlement, law and order, and commerce of the city. James Daugherty, the patriarch, was a rancher and lawyer. He is not pictured here. His sons and daughter are, from left to right, (first row) Mary Edleman, William Ausburn (lawyer), and Daniel Boone (Civil War soldier and potter); (second row) Christopher Columbus (Civil War soldier, sheriff, and merchant), Thomas W. (Civil War soldier, merchant, banker, and lawyer), Matthew (Civil War soldier, sheriff, and county judge), and James Monroe (rancher and banker). (Courtesy of DCOHC.)")])])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img-50",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Bell Avenue Namesakes")])]), _c('br'), _vm._v("Charles C. Bell (1840–1930) came to Denton in 1867 and operated Professor Bell’s Male and Female Academy, a “promising institution,” for two years in the Masonic lodge hall. Bell’s institution was also known as an academy, a high school, a male and female college, and, sometimes, a seminary. By the end of the 1860s, Bell quit teaching and opened a lumber business. He played an instrumental role in planning the two universities. A main artery on the north side of Denton, Bell Avenue, is named for his family. Pictured in the 1920s are C.C. and Elmira Elizabeth Inge Bell (1840–1938). (Courtesy of DPL.)")])])]), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('img', {
    staticClass: "img-60",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F8.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("The Wright Stuff")])]), _c('br'), _vm._v("William Crow Wright (1837–1906) was the owner of the largest ranch in the county, the Chain Seven Ranch, and he was the proprietor of the Wright Opera House. Wright, the patriarch of a large family, poses here with his wife and children. Shown are, from left to right, (first row) Whitney Crow, William Crow, Julia Ann Gober (wife), and Gober Camp; (second row) James Gillenwater, Mary Myrtle, Effie Fay Branche, William Wesley, and Eulallie Carruthers. (Courtesy of DCOHC.)")])])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img-60",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F9.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Mapping the Town")])]), _c('br'), _vm._v("In 1936, her hobby of mapmaking enabled Sena Alleen Mounts Wright (1875–1952) to draw a historical map of the industrial and agricultural resources of Denton County for the Texas Centennial. Illustrated with line drawings, the map above shows major county waterways, towns, landmarks, roads, and railways. Sena Mounts is pictured at right with her husband, William Wesley Wright. (Courtesy of DCOHC.)")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img-60",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F10.jpg"
    }
  })])])]), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img-50",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F11.jpg"
    }
  })])]), _c('p', {
    staticClass: "para1"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Christal Lights")])]), _c('br'), _vm._v("James Russell “Jim” Christal (1859–1936) lost his father and older brother in Denton’s first unsolved murders. His mother, Emily, persuaded her brother, Burk Burnett, to permit Christal to grow up on his cattle ranch, named 6666. Christal returned to Denton after the loss of his lower right leg prevented him from riding horses. He started the Golden Hoof Ranch and, later, built a home on Oak Street. Christal became the first county tax assessor, president of Exchange National Bank, and served on the original North Texas Normal board. An avid letter writer, Christal made friends with newsmakers of his time. He corresponded with Thomas Edison, explaining that he was building a house that would be the first all-electric home on Oak Street. He received a package containing one of the first light fixtures from the Edison Lighting Company, with a card from Edison wishing him happiness with his lights. Christal overcame his physical handicap as he ranched, wrote letters, and provided leadership in Denton. (Courtesy of Annetta Ramsay and Randy Hunt.)")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img-60",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F12.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Furniture and Funerals")])]), _c('br'), _vm._v("John B. Schmitz (1858–1941) opened two complementary businesses: his furniture enterprise, in addition to selling standard pieces, also provided caskets for the funeral home for which he performed mortuary services. Schmitz, who was instrumental in attracting Denton’s large German settlement, helped bring two railroad lines to Denton, organize the first fire department, establish the College of Industrial Arts, and served as a school board member. He ran unsuccessfully for state treasurer, state comptroller, governor, lieutenant governor, and congressman. Although he was never elected to office, Schmitz’s political loyalty was rewarded when Theodore Roosevelt appointed him Denton postmaster. (Courtesy of DCOHC.)")])])]), _c('div', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('img', {
    staticClass: "img-50",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F13.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Sheriff Who Employed an Outlaw")])]), _c('br'), _vm._v("William Franklin “Uncle Billy” Egan (1834–1921) served in the Texas 29th Cavalry with other Denton volunteers during the Civil War. After the war, Egan returned home and worked in a dry-goods store until he was elected sheriff and tax collector. Egan had once employed young Sam Bass as a hired hand. Sheriff Egan was among the men who tracked Bass during his outlaw days. During one of these forays, Bass allegedly snuck up on a sleeping Egan and whispered, “Hello, Uncle Billy” before escaping. (Courtesy of DCOHC.)")])])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "margin-bottom": "0em"
    }
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img-50",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F14.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('b', [_vm._v("Robin Hood of the Cross Timbers")])]), _c('br'), _vm._v("Sam Bass (1851–1878), “Texas’ Beloved Bandit,” came to Denton around 1870. He worked for Sheriff Egan, caring for livestock and hauling freight. Bass bought a fast sorrel mare that became known as the “Denton Mare.” He began racing and gambling and formed an outlaw gang. In 1877, the Sam Bass Gang held up a Union Pacific train, netting $60,000 cash. After dividing the loot, Bass came back to Denton County. He led a crime spree of robbing stagecoaches and trains while hiding out in the thickets of rural Denton County. The fate of Bass’s share fueled speculation about hidden gold in “Sam Bass’ Cave” on Pilot Knob. Texas Rangers and railway-hired Pinkerton men killed Bass in a gun battle in Round Rock on his 27th birthday. This photograph, taken in the summer of 1876, shows Bass (standing, left) with Joe Collins (seated, left), John E. Gardner (standing, right), and Joel Collins (seated, right). (Courtesy of DRC.)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b884d6d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter1.vue
// module id = 84
// module chunks = 0